<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="工单编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.opCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="成品编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                 <el-col :lg="5" :xl="5">
                    <el-form-item label="成品名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                 <el-col :lg="5" :xl="5">
                    <el-form-item label="通道" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getOrderProductData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="是否关闭" class="EL-Form-Item">
                        <el-select v-model="pagination.closeFlag">
                            <el-option label="是" :value = true></el-option>
                            <el-option label="否" :value = false></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
            </el-form>
            <el-divider></el-divider>
            <plabel text="工单">
                <el-button :loading="!loading" v-authority="'BACK_MENU5_M14_1'" class="btn-t-edit">启用</el-button>
                <el-button :loading="!loading" v-authority="'BACK_MENU5_M14_2'" class="btn-t-delete">关闭</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table v-loading="!loading" :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getOrderProductData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="opCode" label="工单编号" />
                <el-table-column prop="matCode" label="成品编号" />
                <el-table-column prop="matName" label="成品名称" />
                <el-table-column prop="whCode" label="通道" />
                <el-table-column prop="closeFlag" label="是否关闭">
                    <template slot-scope="scope">
                        <span v-if="scope.row.closeFlag == true">是</span>
                        <span v-if="scope.row.closeFlag == false">否</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        
                    </template>
                </el-table-column> -->
            </h-table>
        </box>
    </div>
</template>

<script>
export default {
    name: "StockCheckTaskDetail",
    data() {
        return {
            headerCellStyle: () => {
                return "background-color: #1f5cec";
            },
            form: {},

            showRoleBox: true,
            add_or_edit: Boolean, //新增|编辑
            editBoxShow: false, //编辑框
            dialogFormVisible: false,
            formLabelWidth: "140px", // 对话框大小
            tableHeight: 0, //表格高度
            testValue: 1,
            mainObj: {},
            pagination: {
                pageSize: 50,
                pageNum: 1,
                opCode: "",
                matCode: "",
                matName: "",
                whCode: "",
                closeFlag: false,
            },
            tableTotal:0,
            mainData: [],
            fcode: localStorage.getItem("fcCode") || "",

            downloadLoading: false, //下载中

            loading: 0,

            logContent: "", //操作日志-内容
            logRemarks: "", //操作日志-备注
            // 输入框延时加载
            isSetTimeout: null,
        };
    },
    watch: {
        pagination: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getOrderProductData(newVal);
                }, 1000)
            },
            deep: true,
        },
    },
    methods: {
        //获取数据
        getOrderProductData() {
          this.loading++
          var paramsObj = {
            pageSize: this.pagination.pageSize,
            pageNum: this.pagination.pageNum,
            opCode: this.pagination.opCode,
            matCode: this.pagination.matCode,
            matName: this.pagination.matName,
            whCode: this.pagination.whCode,
            // closeFlag: this.pagination.closeFlag,
          }
            this.$http
                .request({
                    url: "/api/orderProduct/getOrderProductData",
                    method: "GET",
                    params: paramsObj,
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.mainData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {

                });
        },
        //表单验证
        submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    r = true;
                } else {
                    r = false;
                }
            });
            return r;
        },
        //框打开
        open() {
            if (this.add_or_edit) {
                //新增
                this.mainObj = JSON.parse(JSON.stringify({}));
            } else {
                this.getOrderProductData();
            }
        },
        //新增
        add() {
            if (this.fcode != "") {
                this.mainObj.fcCode = this.fcode;
            }
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/material/insertMaterial",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "material：物料新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "material：物料新增失败";
                        }
                        this.logContent =
                            "mtCode：" +
                            this.mainObj.mtCode +
                            "\t mtName" +
                            this.mainObj.mtName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getOrderProductData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //编辑
        editRow() {
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/material/updateMaterial",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "material：物料编辑成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "material：物料编辑失败";
                        }
                        this.logContent =
                            "mtCode：" +
                            this.mainObj.mtCode +
                            "\t mtName" +
                            this.mainObj.mtName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getOrderProductData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //删除
        deleteRow(mtId) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/material/deleteMaterial",
                            method: "DELETE",
                            showLoading: true,
                            params: {
                                mtId: mtId,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：物料删除成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "删除失败",
                                });
                                this.logRemarks = "material：物料删除失败";
                            }
                            this.logContent = "mtId：" + mtId;
                            this.systemLog();
                            this.getOrderProductData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        //重置
        resetData() {
            this.pagination = {
                pageSize: 50,
                pageNum: 1,
                mtCode: "",
                mtName: "",
                fcCode: localStorage.getItem("fcCode"),
            };
            this.tableTotal=0;
            // this.getOrderProductData();
        },

        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var paramsObj = {
                mtCode: this.pagination.mtCode,
                mtName: this.pagination.mtName,
                mtCheck: this.pagination.mtCheck,
                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/material/getMaterialAll',
                method: 'GET',
                showLoading: true,
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    if (c.mtCheck == '10') {
                        c['mtCheck'] = '全检'
                    } else if (c.mtCheck == '20') {
                        c['mtCheck'] = '免检'
                    } else if (c.mtCheck == '30') {
                        c['mtCheck'] = '抽检'
                    }

                    if (c.mtXa == true) {
                        c['mtXa'] = '是'
                    } else if (c.mtXa == false) {
                        c['mtXa'] = '否'
                    }
                })
                const tHeader = ['物料编号', '物料描述', '单位', '检查类型', '物料类型', '是否来自XA系统', '有效日期(月份)']
                const filterVal = ['mtCode', 'mtName', 'mtUnit', 'mtCheck', 'ddName', 'mtXa', 'validityMonth']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '物料数据'
                })
                this.logContent = "导出"
                this.logRemarks = "sys_material：导出物料数据"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },


        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "物料主数据",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated() {
        /* 获取首页的数据 */
        this.getOrderProductData();
    },
};
</script>

<style scoped>
</style>